import { useCallback } from 'react';
import type { NavigateOptions, To } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Wraps React Router `navigate` so transitions that start on a `/content/...`
 * detail route use `flushSync: true`, avoiding stale UI when the URL updates.
 */
export function useNavigateWithContentFlush() {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (to: To, options?: NavigateOptions) => {
      const fromContent = location.pathname.startsWith('/content/');
      if (fromContent) {
        navigate(to, { ...options, flushSync: true });
        return;
      }
      navigate(to, options);
    },
    [navigate, location.pathname]
  );
}
